import { AVAILABLE_QUANTITY } from '../../../../../../../ContractBuilder/ProductsManage/ProductsTable/cols/DatesCol/DatesCell/EditPeriods/DatePickerPeriodSelector/hooks/useInventoryPeriods'

export function useProductQuantityLimits(productPeriodDates) {
  // find the lowest availableQuantity quantity and set it as max quantity
  const availableQuantity = productPeriodDates.map(option => option[AVAILABLE_QUANTITY])
  const maxProductQuantity = Math.min(...availableQuantity)

  return maxProductQuantity
}
